<template>
  <div class="h-100">
    <v-row class="h-100">
      <v-col class="h-100" cols="12">
        <v-row class="h-20">
          <v-col>Throughput :</v-col>
          <v-col class="text-right">{{ throughput.value }}</v-col>
        </v-row>
        <v-row class="h-30">
          <v-col class="h-85">
            <!-- eslint-disable-next-line prettier/prettier -->
            <chart-throughput
              ref="throughput"
              :values="throughput.values"
              area-style="linearGradient"
              :x-axis-length="xAxisLength"
              :contextmenu="contextmenuChart"
            />
          </v-col>
        </v-row>
        <v-row class="h-20">
          <v-col>Response Time :</v-col>
          <v-col class="text-right">
            <span class="mr-1">{{ responsetime.value }}</span>
            <span>ms</span>
          </v-col>
        </v-row>
        <v-row class="h-30">
          <v-col class="h-85">
            <!-- eslint-disable-next-line prettier/prettier -->
            <chart-responsetime
              ref="responsetime"
              :values="responsetime.values"
              area-style="linearGradient"
              :x-axis-length="xAxisLength"
              :contextmenu="contextmenuChart"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </v-row>
  </div>
</template>

<script>
import { parse } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import bus from '@/utils/bus';
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';
import ChartThroughput from '../chart/LineSingle.vue';
import ChartResponsetime from '../chart/LineSingle.vue';

export default {
  mixins: [instanceable, contextmenuable],
  components: {
    ChartThroughput,
    ChartResponsetime,
  },
  data() {
    return {
      xAxisLength: 20,
      throughput: {
        value: 0,
        values: [],
      },
      responsetime: {
        value: 0,
        values: [],
      },
      messageNames: ['rawWorkload.3sec', 'rawWorkloadOwl.3sec', 'rawWorkloadSys.3sec'],
      messageFields: ['stime', 'endtimestamp', 'totStep', 'avgRespti'],
      buffers: [],
      syncTime: null,
    };
  },
  watch: {},
  methods: {
    contextmenuChart(event) {
      event.preventDefault();
      const query = {
        // BEGIN::Modified.by.KWShin.2025.01.21.
        // 아웅... 이걸 그냥 현재 시각을 넘기면 Context Analyzer에서 데이터가 나오겠냐...
        // 차트에서 넘겨받은 시점을 넘기는 것으로 수정함.
        // dt: new Date().getTime(),
        dt: this.syncTime,
        // FINISH::Modified.by.KWShin.2025.01.21.
        sid: this.instance.systemId,
        iid: this.instance.id,
      };
      this.contextmenuParam = {
        show: true,
        x: event.clientX,
        y: event.clientY,
        items: [
          {
            icon: 'mdi-layers-search',
            // BEGIN::Modified.by.KWShin.2025.01.21.
            // 메뉴 타이틀이 하드코딩 되어 있어서 메시지코드로 바꾸었다.
            // 새로운 Context Analyzer가 진즉 완성되었다. 연결 변경.
            // text: 'Context Analysis',
            text: this.$t('ctxt.menu.title'),
            //handler: () => window.open(`/views/analysis/context?${new URLSearchParams(query).toString()}`, '_blank'),
            handler: () => window.open(`/views/analysis/context-analyzer?${new URLSearchParams(query).toString()}`, '_blank'),
            // FINISH::Modified.by.KWShin.2025.01.21.
          },
        ],
      };
    },
    wsBufferedDataHandler(key, responses) {
      const [response] = responses;
      // BEGIN::Modified.by.KWShin.2024.03.06.
      // WebSocket 구독 시 bufferSize 지정 기능이 추가되어
      // 구독 시 길이를 지정하였으므로 굳이 여기서 다시 안 잘라도 됨.
      // const bound = response.length < this.xAxisLength ? response.length : this.xAxisLength;
      // this.buffers.push(response.slice(response.length - bound));
      this.buffers.push(response);
      // FINISH::Modified.by.KWShin.2024.03.06.
      // 모든 메세지값이 취합되었을 경우
      if (this.buffers.length == this.messageNames.length) {
        const merged = [];
        this.buffers.forEach(responses => {
          responses.forEach(response => {
            response.data.forEach(d => {
              // BEGIN::Modified.by.KWShin.2023.07.21.
              // date-fns-tz을 1.0.2에서 2.0.0으로 upgrade 하였더니 아래줄에서 zonedTimeToUtc()에서 정상적으로 Date를 리턴하지 않는다.
              // 그래서 수정.
              // const ctime = zonedTimeToUtc(format(parse(d.endtimestamp, 'yyyyMMddHHmmss', new Date()), 'yyyy-MM-dd HH:mm:ss.SSS'), { timeZone: this.$store.state.common.user.timeZoneId }).getTime();
              const ctime = zonedTimeToUtc(parse(d.endtimestamp, 'yyyyMMddHHmmss', new Date()), 'UTC').getTime();
              // FINISH::Modified.by.KWShin.2023.07.21.
              let target = merged.find(m => m.ctime == ctime);
              const data = {
                totStep: d.totStep ? parseInt(d.totStep) : 0,
                avgRespti: d.avgRespti ? parseFloat(d.avgRespti) : 0.0,
              };
              if (target) {
                target = {
                  ctime: target.ctime,
                  stime: target.stime,
                  data: target.data.push(data),
                };
              } else {
                merged.push({
                  ctime,
                  stime: ctime,
                  data: [data],
                });
              }
            });
          });
        });
        this.buffers = [];
        this.dataHandler(merged);
      }
    },
    wsDataHandler(key, response) {
      this.buffers.push(response);
      if (this.buffers.length == this.messageNames.length) {
        const merged = [];
        this.buffers.forEach(item => {
          item.forEach(d => {
            // BEGIN::Modified.by.KWShin.2023.07.21.
            // date-fns-tz을 1.0.2에서 2.0.0으로 upgrade 하였더니 아래줄에서 zonedTimeToUtc()에서 정상적으로 Date를 리턴하지 않는다.
            // 그래서 수정.
            // const ctime = zonedTimeToUtc(format(parse(d.endtimestamp, 'yyyyMMddHHmmss', new Date()), 'yyyy-MM-dd HH:mm:ss.SSS'), { timeZone: this.$store.state.common.user.timeZoneId }).getTime();
            const ctime = zonedTimeToUtc(parse(d.endtimestamp, 'yyyyMMddHHmmss', new Date()), 'UTC').getTime();
            // FINISH::Modified.by.KWShin.2023.07.21.
            let target = merged.find(m => m.ctime == ctime);
            const data = {
              totStep: d.totStep ? parseInt(d.totStep) : 0,
              avgRespti: d.avgRespti ? parseFloat(d.avgRespti) : 0.0,
            };
            if (target) {
              target = {
                ctime: target.ctime,
                stime: target.stime,
                data: target.data.push(data),
              };
            } else {
              merged.push({
                ctime,
                stime: ctime,
                data: [data],
              });
            }
          });
        });
        this.buffers = [];
        this.dataHandler(merged);
      }
    },
    dataHandler(data) {
      const slice = data.length - this.xAxisLength;
      const d = slice > 0 ? data.slice(data.length - slice) : data;
      const handled = d.map(item => {
        const sum = item.data.reduce(
          (acc, d) => ({
            totalStep: acc.totalStep + parseInt(d.totStep),
            totalAverage: acc.totalAverage + parseFloat(d.avgRespti) * parseInt(d.totStep),
          }),
          {
            totalStep: 0,
            totalAverage: 0,
          },
        );
        return {
          ctime: item.ctime,
          stime: item.stime,
          throughput: sum.totalStep,
          responsetime: sum.totalStep ? Math.round(sum.totalAverage / sum.totalStep / 1000) : 0,
        };
      });
      const removeCount = this.throughput.values.length > handled.length ? handled.length : this.throughput.values.length;
      this.throughput.values.splice(0, removeCount);
      this.throughput.values = this.throughput.values.concat(handled.map(item => ({ name: parseInt(item.ctime), value: item.throughput })));
      this.throughput.value = this.throughput.values.length ? this.throughput.values[this.throughput.values.length - 1].value : 0;

      this.responsetime.values.splice(0, removeCount);
      this.responsetime.values = this.responsetime.values.concat(handled.map(item => ({ name: parseInt(item.ctime), value: item.responsetime })));
      this.responsetime.value = this.responsetime.values.length ? this.responsetime.values[this.responsetime.values.length - 1].value : 0;
    },
  },
  created() {
    this.$websocket.realtime.send({
      requests: this.messageNames.map(name => ({
        key: { name: name, sstmId: this.instance.systemId, instId: this.instance.id },
        fields: this.messageFields,
        // Added.by.KWShin.2024.03.06.
        bufferSize: this.xAxisLength,
        handler: {
          buffer: this.wsBufferedDataHandler,
          every: this.wsDataHandler,
        },
      })),
    });
    // BEGIN::Added.by.KWShin.2025.01.21.
    // ../chart/LineSingle.vue에서 차트 툴팁이 표시될 때 마우스가 가리키는 시점의 시각이 넘어온다.
    bus.$on(`line-single-tooltip`, syncTime => {
      this.syncTime = syncTime;
    });
    // FINISH::Added.by.KWShin.2025.01.21.
  },
};
</script>
